<template>
  <div class="calendar-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <span class="page-title">Select Order Date</span>
    </div>

    <!-- Cart -->
    <div class="section-pad" v-if="cart.length > 0">
      <Cart show-delete="false" show-quantity="false" show-notes="false" show-checkout="true"></Cart>
    </div>

    <!-- Section label -->
    <div class="section-pad">
      <p class="days-label">Available Days</p>
      <div class="days-grid">
        <div class="calendar-container" v-for="day in daysLimited" v-bind:key="day.day">
          <div class="day-card match-height" v-on:click="setPreOrderDate(day)">

            <!-- Order count badge (kept for jQuery grayed class) -->
            <div class="order-badge" v-bind:class="'day-' + day.day" v-if="countOrders(day) > 0">
              {{ countOrders(day) }}
            </div>

            <div class="day-name">{{ titleCase(day.day_name) }}</div>
            <div class="day-number">{{ day.day }}</div>
            <div class="day-meta">
              <span class="day-month">{{ day.month_name }}</span>
              <span class="day-year">{{ day.year }}</span>
            </div>
<!-- 
            <div class="day-card-arrow"><i class="ft-chevron-right"></i></div> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'
import Cart from '@/components/navigation/Cart.vue'
import moment from "moment";

export default {
  name: 'calendar',
  components: { Cart },
  computed: {
    daysLimited: function () {
      return this.days.slice(0, 7)
    }
  },
  data: function () {
    return {
      days: [],
      periods:[],
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : []
    }
  },
  mounted: function () {
    window.localStorage.setItem('nil_per_mouth_periods', '')
    this.$store.commit('SET_LAYOUT', 'AppLayout')
    var that = this
    var user = JSON.parse(window.localStorage.getItem('user'))
    var merchantId = user.merchant.id
    var bedId = this.$route.params.bed
    var bed = ""
    if(window.localStorage.getItem('bed') != undefined && 
      window.localStorage.getItem('bed') != null && 
      window.localStorage.getItem('bed') != ''){
       bed = JSON.parse(window.localStorage.getItem('bed'))
    }
     var ward =  ""
    if(window.localStorage.getItem('ward') != undefined && 
      window.localStorage.getItem('ward') != null && 
      window.localStorage.getItem('ward') != ''){
        var ward = JSON.parse(window.localStorage.getItem('ward'))
    }
    
    var url = this.$config.apiUrl +'medicater/calendar/?merchant_id=' + merchantId + '&bed_id=' + bedId
    if(window.localStorage.getItem('free_issue') == "Y"){
      
      url = this.$config.apiUrl +'canteenapp_basic/calendar_free_issues?ward_id='+ward.ward_id
    }
    $.showLoading()
    $.ajax({
       beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        },
       url: url,
      type: 'get',
      dataType: 'json',
      success: function (data) {
        $.hideLoading()
        if(window.localStorage.getItem('free_issue') == "Y"){
          that.days = data.data
        }else{
          that.days = data.data.calendar
        }
        var periods = []
        data.data.periods_new.forEach(function (period) {
          periods.push({
            id: period.id,
            title: period.name,
            open_time: period.period_open_time,
            close_time: period.period_close_time,
            cut_off: period.period_cut_off,
            served: "("+period.period_open_time+"-"+period.period_close_time+")"
          })
        })

        that.periods = periods

        setTimeout(function () {
          $('.match-height').matchHeight()
        }, 1000)
      },
      error: function (data) {
        $.hideLoading()
        if (window.localStorage.getItem(this.url)) {
          that.logout()
          var offlineData = JSON.parse(window.localStorage.getItem(this.url))
          this.success(offlineData)
        } else {
              //var message = data.responseJSON.message
              //if(message == undefined){
               var message = "Oops, something went wrong, please try again later."
              //}

              swal({
                text: message,
                icon: 'info',
                button: 'Ok'
              })
              .then(function (data) {
                that.$router.push('/')
              })
        }
      }
    })
  },
  methods: {
    cutOffReached: function (periodId, date){
      var that = this
      var returnVal = false

      if(date === moment().format('YYYY-MM-DD')) {
        that.periods.forEach(function (period) {

          if(periodId == period.id){

            var currentUnix = moment().format('X')
            var endUnix = moment(date + ' ' + period.close_time).format('X')

            if (currentUnix > endUnix) {
              console.log(currentUnix +">"+ endUnix)
              returnVal = true
            } else {
              returnVal = false
            }
          }
        })
      }

      return returnVal
    },
    setPreOrderDate: function (day) {
      if(day.nil_per_mouth_periods.length > 0){
        window.localStorage.setItem('nil_per_mouth_periods', JSON.stringify(day.nil_per_mouth_periods))
      }else{
        window.localStorage.setItem('nil_per_mouth_periods', JSON.stringify([]))
      }
      window.localStorage.setItem('date', day.date)
      if(window.localStorage.getItem('free_issue') == "Y"){
        window.localStorage.setItem('period', JSON.stringify({title:'',id:'1'}))
        window.localStorage.setItem('bed', JSON.stringify({menu_type_id:'0',bed_id:'0',ward_id:''}))
        var bed = JSON.parse(window.localStorage.getItem('bed'))
        this.$router.push('/preorder/' + this.$route.params.ward + '/' + this.$route.params.bed + '/' + day.date + '/1/categories')
        return false
      }
      this.$router.push('/preorder/' + this.$route.params.ward + '/' + this.$route.params.bed + '/' + day.date)
    },
    titleCase: function (str) {
      if (!str) return ''
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    },
    countOrders: function (day) {
      var counter = 0
      var items = []
      var that = this
      for (var key in day.orders) {
        items = day.orders[key][0].items
        counter = counter + items.length

        if(that.cutOffReached(day.orders[key][0].period_id, day.orders[key][0].date)){
          setTimeout( function (){
            $(".day-"+day.day).addClass("grayed")
            console.log('cut off reached', that.cutOffReached(day.orders[key][0].period_id, day.orders[key][0].date))
            console.log('".day-"+day.day', ".day-"+day.day)
          }, 300)
        }else{
          $(".day-"+day.day).removeClass("grayed")
        }


      }

      return counter
    }
  }
}
</script>

<style scoped>
.calendar-page {
  min-height: 100vh;
  padding-bottom: 32px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.15);
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255,255,255,0.25); }

.page-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.3px;
}

/* ── Section ── */
.section-pad { padding: 66px 14px 0; }

.days-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: rgba(255,255,255,0.55);
  margin: 0 0 12px;
}

/* ── Grid ── */
.days-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

/* ── Day card ── */
.calendar-container { position: relative; }

.day-card {
  position: relative;
  background: #fff;
  border-radius: 14px;
  padding: 16px 12px 12px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.day-card:active {
  transform: scale(0.97);
  box-shadow: 0 1px 6px rgba(0,0,0,0.08);
}

/* Today — first card gets gradient treatment */
.calendar-container:first-of-type .day-card {
  background: linear-gradient(135deg, #0f4c81 0%, #1a8a7a 100%);
  box-shadow: 0 6px 20px rgba(15,76,129,0.35);
}

.calendar-container:first-of-type .day-name,
.calendar-container:first-of-type .day-month,
.calendar-container:first-of-type .day-year,
.calendar-container:first-of-type .day-meta,
.calendar-container:first-of-type .day-card-arrow {
  color: rgba(255,255,255,0.75) !important;
}

.calendar-container:first-of-type .day-number {
  color: #fff !important;
}

/* Today label strip */
.calendar-container:first-of-type .day-card::before {
  content: "TODAY";
  display: block;
  font-size: 0.55rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  background: rgba(255,255,255,0.2);
  color: #fff;
  padding: 2px 8px;
  border-radius: 999px;
  margin-bottom: 6px;
}

.day-name {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #94a3b8;
}

.day-number {
  font-size: 2rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1;
  margin: 4px 0;
}

.day-meta {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.day-month {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
}

.day-year {
  font-size: 0.65rem;
  color: #94a3b8;
}

.day-card-arrow {
  margin-top: 8px;
  font-size: 0.75rem;
  color: #cbd5e1;
}

/* ── Order badge ── */
.order-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  min-width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 2px 6px rgba(239,68,68,0.4);
}

/* jQuery adds this class when cut-off is reached */
.order-badge.grayed {
  background: #94a3b8 !important;
  box-shadow: none !important;
}
</style>
